import React, { useEffect } from "react";
import { updateMatches } from "../utils/generalLiveCenter";

export const useCricketSocket = (socket, sport, setData, allowedLeagues) => {
    useEffect(() => {
        if (!socket || !allowedLeagues?.length) return;

        let event = "";
        if (sport === "tennis") event = "TTMatchesUpdated";
        else if (sport === "basketball" || sport === "icehockey") event = "BBMatchesUpdated";
        else if (sport === "cricket") event = "CRICMatchesUpdated";

        const channel = socket.channel("IPUB").listen(event, (e) => {
            console.log("Socket update:", new Date().toLocaleString(), e?.data);

            setData((prevState) => {
                const rawData = e?.data;
                let socketData;

                if (allowedLeagues) {
                    if (sport === "cricket") {
                        const allowed = allowedLeagues || [];
                        socketData = rawData?.filter(l =>
                            l.matches?.some(match =>
                                allowed?.includes(match.competitors?.htid)
                            )
                        )

                    } else {
                        const allowed = Array.isArray(allowedLeagues)
                            ? allowedLeagues
                            : allowedLeagues?.data || [];
                        socketData = rawData?.filter((l) => allowed.includes(l?.lid));
                    }
                } else {
                    socketData = rawData;
                }
                let nextState = [];

                // update existing leagues
                prevState?.forEach((l) => {
                    let tempLeague = socketData.find((x) => x.id === l.id);

                    if (!tempLeague) {
                        nextState.push(l);
                    } else {
                        let updatedLeague = { ...l, matches: [] };

                        l?.matches.forEach((m) => {
                            let tempMatch = tempLeague?.matches?.find((x) => x.id === m.id);
                            updatedLeague.matches.push(
                                tempMatch ? updateMatches(m, tempMatch, sport) : m
                            );
                        });

                        // add new live matches dynamically
                        tempLeague.matches.forEach((m) => {
                            let tempMatch = l?.matches?.find((x) => x.id === m.id);
                            if (!tempMatch) updatedLeague.matches.push(m);
                        });

                        nextState.push(updatedLeague);
                    }
                });

                // add new leagues
                socketData.forEach((l) => {
                    if (!prevState.find((x) => x.id === l.id)) {
                        nextState.push(l);
                    }
                });

                // filter finished or cancelled matches/leagues
                nextState = nextState.map((l) => {
                    const finishedMatches = l?.matches?.filter((m) =>
                        [
                            "Finished",
                            "Finished AP",
                            "Finished AET",
                            "Awarded",
                            "Cancelled",
                            "Postponed",
                            "Abandoned",
                            "Deleted",
                            "Result Only",
                            "Stumps",
                        ].includes(m?.st || m?.bs)
                    );

                    if (finishedMatches?.length === l?.matches?.length) {
                        return { ...l, removeLeague: "true" };
                    }

                    const finishedIds = finishedMatches?.map((m) => m?.id);
                    return {
                        ...l,
                        matches: l.matches.map((m) =>
                            finishedIds.includes(m.id) ? { ...m, removeMatch: "true" } : m
                        ),
                    };
                });

                return nextState;
            });
        });

        return () => {
            channel?.stopListening(event);
            socket?.connector?.socket.disconnect();
        };
    }, [socket, sport, setData, allowedLeagues]);
};
